import React from 'react'
import { CSSTransition } from 'react-transition-group'
import { ElementType, ReactNode, useRef } from 'react'
import './Animator.scss'
import { emptyFunc } from '../../../types/constants'
import { LoadingSpinner } from '../LoadingSpinner/LoadingSpinner'

interface IProps {
  /** Show fragment. */
  visible?: boolean
  /** Content to be animated. */
  children: ReactNode
  /** Animation type. Fade by default. */
  type?: 'fade' | 'fade-rubber' | 'scale'
  /** Tag type. <div> by default. */
  tag?: ElementType
  /** Class names attribute. */
  className?: string
  /** Content is loading. */
  loading?: boolean
  /** onClick attribute. */
  onClick?: (e: React.MouseEvent) => void
  /** onMouseDown attribute. */
  onMouseDown?: (e: React.MouseEvent) => void
  /** onClick attribute. */
  rubber?: boolean
}

/**
 * Animates the selected render fragment based on visibility.
 */
export const AnimatedFragment = (props: IProps) => {
  const nodeRef = useRef(null)

  // Sets default props
  const {
    type = 'fade',
    tag = 'div',
    onClick = () => emptyFunc(),
    onMouseDown = () => emptyFunc(),
    loading = false,
  } = props

  const SelectedTag = tag

  const loader = () => {
    return loading && props.visible && <LoadingSpinner />
  }

  const render = () => {
    return (
      <CSSTransition
        in={props.visible && !props.loading}
        nodeRef={nodeRef}
        classNames={type}
        timeout={300}
        unmountOnExit
      >
        <SelectedTag
          ref={nodeRef}
          className={props.className}
          onClick={(e: React.MouseEvent) => onClick(e)}
          onMouseDown={(e: React.MouseEvent) => onMouseDown(e)}
          translate="no"
        >
          {props.children}
        </SelectedTag>
      </CSSTransition>
    )
  }

  return (
    <>
      {loader()}
      {render()}
    </>
  )
}
